import React from 'react';
import StatusBlock from '../../../../../components/StatusBlock'

const filters = () => [
	{
		label: "Не прочитан",
		display: item => item.tipNovayaInfa,
		name: "tipNovayaInfa",
		type: "bool",
		sort: true,
		filter: true,
		sorted: "DESC"
	},
	{
		label: "Дата статуса",
		display: item => item.status.dataPoslednegoIzmeneniya,
		name: "dataPoslednegoIzmeneniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Тип участия",
		display: item => item.status.tekst01TipUchastiyaVFederatsii,
		name: "tekst01TipUchastiyaVFederatsii",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Регион",
		display: item => item.status.tekst11RO,
		name: "tekst11RO",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Текущий статус",
		display: item => item.status.tekst04StatusPoPriemu,
		name: "tekst04StatusPoPriemu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор",
		display: item => item.status.tekst02Initsiator,
		name: "tekst02Initsiator",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Орган принятия решения",
		display: item => item.status.tekst12OgranPrinyatiyaResheniya,
		name: "tekst12OgranPrinyatiyaResheniya",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Вопрос повестки дня",
		display: item => item.status.tekst13VPD,
		name: "tekst13VPD",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата инициирования",
		display: item => item.status.tekst03DataInitsiirovaniya,
		name: "tekst03DataInitsiirovaniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата реального назначения",
		display: item => item.status.tekst05DataPriema,
		name: "tekst05DataPriema",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата начала работы",
		display: item => item.status.tekst15DataNachalaRaboti,
		name: "tekst15DataNachalaRaboti",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор исключения",
		display: item => item.status.tekst07InitsiatorPoisklyucheniyu,
		name: "tekst07InitsiatorPoisklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата заявки на исключение",
		display: item => item.status.tekst06DataPodachiNaIsklyuchenie,
		name: "tekst06DataPodachiNaIsklyuchenie",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Статус по исключению",
		display: item => item.status.tekst08StatusPoIsklyucheniyu,
		name: "tekst08StatusPoIsklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата исключения",
		display: item => item.status.tekst09DataIsklyucheniya,
		name: "tekst09DataIsklyucheniya",
		type: "date",
		sort: true,
		filter: true
	}
];

export default function Status(props) {
	return (
		<>
			<StatusBlock {...props} filters={filters} uuid="bfc5b9b181ab"/>
		</>
	);
}
